/**
 * Users Feature Routes
 */
import type { RouteRecordRaw } from 'vue-router';
import i18next from 'i18next';

export const usersRoutes: RouteRecordRaw[] = [
  {
    path: '/users',
    name: 'users',
    component: () => import('./views/UsersListView.vue'),
    meta: {
      title: () => i18next.t('users.title'),
      requiredEntitlement: 'USER_MANAGEMENT',
    },
  },
];
